/*
 *
 * LicenseTable
 *
 */

import styled from 'styled-components';

import media from '../../style/mediainjector';

export const LicenseTable = styled.table`
  width: 100%;
  /* max-width: 1024px; */
  border-collapse:collapse;
  border-spacing:0;
  margin: 0 auto;
  text-align: center;
  border: none;
  margin-bottom: 1.6rem;
  tr {
    border-bottom: 1px solid #999;
    ${media.lt667`
      border-bottom: none;
    `}
    &:last-child {
      border-bottom: none;
    }
    td,
    th {
      padding: 15px;
      ${media.lt667`
        padding: 15px 10px;
      `}
    }
  }
  thead {
    border-top: 2px solid #000;
    ${media.lt667`
      border-top-width: 1px;
    `}
  }
  thead,
  .title {
    color: #000;
    font-weight: 600;
    border-bottom: 2px solid #000;
  }
  thead,
  .licenza {
    font-weight: 600;
  }
  .licenza {
    max-width: 180px;
    ${media.lt667`
      font-size: 1.5rem;
      padding: 10px;
      border-top: 1px solid #d2d2d2;
    `}
  }
  .title {
    background-color: rgba(0,0,0,0.1);
  }
  .active{
    opacity: 1;
  }
  .disabled{
    opacity:.5;
    text-decoration: line-through;
  }
  .descrizione {
    font-weight: 400;
    font-size: 1.3rem;
    margin: 0;
  }
  .validita {
    font-size: 1.5rem;
    ${media.lt667`
      font-size: 1.2rem;
    `}
  }
  .legenda {
    font-size: 1.3rem;
    ${media.lt667`
      font-size: 1rem;
      border-top: 1px solid #d2d2d2;
    `}
  }
  td {
    word-wrap: break-word;
    overflow-wrap: break-word;
  }

  // table mobile
  ${media.lt667`
    /* Force table to not be like tables anymore */
    font-size: 1.2rem;
    thead, tbody, th, td, tr {
      display: block;
    `}
    tbody {
      border-bottom: 1px solid #000;
    }
    /* Hide table headers (but not display: none;, for accessibility) */
    thead {
      border-bottom: 0;
      tr {
        position: absolute;
        top: -9999px;
        left: -9999px;
      }
    }

    td {
      /* Behave  like a "row" */
      border: none;
      border-bottom: 1px solid #d2d2d2;
      position: relative;
      text-align: left;
      padding-left: 70px !important; // TOFIX diosanto
      &:last-child {
        border-bottom: none;
      }
    }

    td:before {
      /* Now like a table header */
      position: absolute;
      /* Top/left values mimic padding */
      top: 0px;
      left: 0px;
      bottom: 0px;
      width: 60px;
      padding-left: 10px;
      white-space: nowrap;
      text-align: left;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      background: rgba(0,0,0,0.05);
    }

    .licenza{
      max-width:100%;
      background: rgba(0,0,0,0.3);
      text-align: center;
      padding-left: 0px !important; // TOFIX diosanto
      &:before{
        background: transparent;
      }
      ${media.lt667`
        background: rgba(0,0,0,0.1);
      `}
    }
    .legenda {
      padding: 10px !important; // TOFIX diosanto
    }
    /*
    Label the data
    */
    td:nth-of-type(1):before { display:none }
    td:nth-of-type(2):before { content: "ISBN"; font-weight: 600; }
    td:nth-of-type(3):before { content: "Durata"; font-weight: 600; }
    td:nth-of-type(4):before { content: "Prezzo"; font-weight: 600; }
    td:nth-of-type(5):before { content: "Offerta"; font-weight: 600; }
  }
`;
